module.exports = __webpack_public_path__ + "img/face_default.a184bec0.jpg";